import React from 'react'

import GalleryInput from './GalleryInput'

const DocumentInput = ({ onChange, ...props }) => {
  const handleChange = value => onChange(Boolean(value?.length) ? value[0] : null)

  const value = props.value ? [props.value] : null

  return <GalleryInput {...props} onChange={handleChange} value={value} limit={1} />
}

export default DocumentInput
